export const TYPECIRCLARS = `/v2/guest/regulations?model=circular`;
export const CIRCLARS = (id) => `/v2/guest/regulations/${id}?model=circular`;
